// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'neueMontreal', 'neueMontreal Fallback'"},"className":"__className_444f86","variable":"__variable_444f86"};